
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
//import {AfterViewInit, ViewChild} from '@angular/core';
//import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
//import {MatTableDataSource} from '@angular/material/table';
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { CourseService } from "../../services/course.service";
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from '@angular/common';
export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}
/** Constants used to fill up our data base. */
const COLORS: string[] = [
  'maroon', 'red', 'orange', 'yellow', 'olive', 'green', 'purple', 'fuchsia', 'lime', 'teal',
  'aqua', 'blue', 'navy', 'black', 'gray'
];
const NAMES: string[] = [
  'Maia', 'Asher', 'Olivia', 'Atticus', 'Amelia', 'Jack', 'Charlotte', 'Theodore', 'Isla', 'Oliver',
  'Isabella', 'Jasper', 'Cora', 'Levi', 'Violet', 'Arthur', 'Mia', 'Thomas', 'Elizabeth'
];

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss'],
  providers: [DatePipe]
})
export class CourseComponent implements OnInit {
  minDate = new Date();
  activeCourse: boolean = true;
  succesCourse: boolean = false;
  closeResult = ''; courseData: any = []; cousesData: any = []; courseIdEndDate: any = '';
  status: any = 1; adminData: any; tabName: any = ''; course_id: any = '';
  courseListData: any = []; tabIndex: number = 0; page: any = '';
  course_name = ""; course_status = "2"; is_active = "1"; order_by = "created_dttm"; order = "DESC";
  courseForm: any = []; moduleData: any = [];
  extendForm = new FormGroup({
    endDate: new FormControl(new Date(), [Validators.required]),
  });
  get fv() { return this.extendForm.controls; }

  constructor(private modalService: NgbModal, private contentAuthoringApi: ContentAuthoringService, private router: Router,
    private spinner: NgxSpinnerService, private authCours: CourseService, private route: ActivatedRoute, private datePipe: DatePipe) {
    if (localStorage.getItem('adminData') == '' || localStorage.getItem('adminData') == null) {
      this.router.navigateByUrl('/admin-login');
    }
  }

  ngOnInit(): void {
   
    this.spinner.show();
    this.is_active = '1';
    this.authCours.lastSelectedTab.subscribe(res=> {
      this.tabIndex=res;
    })
    this.route.queryParams.subscribe(queryParams => {
      this.tabIndex = queryParams['tab'];
      if (this.tabIndex == 2) {
        this.course_status = '1';
      }
      if (this.tabIndex == 1) {
        this.is_active = '0';
      }
    })

    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
  }

  open0(content02: any, corseId: any) {
    this.courseIdEndDate = corseId;
    this.modalService.open(content02, { centered: true, size: 'md' });
  }
  open(content: any, course_id: any, tab_name: any) {
    this.tabName = tab_name;
    this.course_id = course_id;
    this.modalService.open(content, { size: 'sm', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    //this.succesDelAssessment = false;
    //.activeDleMod = true;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  /*******status change in active or deactive  *****/
  changeIsDeActiveVal(course_id: any, is_actives: any) {
    this.changeIsActiveVal(course_id, is_actives);
  }
  coursePublised(course_id: any) {
    this.authCours.CoursePublish(course_id).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
          // this.router.navigate(['/courses']);
        } else {
          // this.errorInfo.isError = true;
          // this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  changeIsActiveVal(course_id: any, is_active: any) {
    //console.log(course_id,is_active);
    this.authCours.changeIsActiveVal(course_id, is_active).subscribe(
      (data) => {
        // console.log(data);
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
          this.router.navigate(['/courses']);
        } else {
          // this.errorInfo.isError = true;
          // this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  /*******delete course from draft *****/
  deleteCourse(course_id: any) {
    this.authCours.deletesCourse(course_id).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
        } else {
        }
      },
      (error) => { },
    );
  }
  /***** Shorting listing by course name****/
  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = 'ASC';
    } else { this.order_by = 'end_date'; this.order = 'DESC'; }
    this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
  }
  onSelectChange(event: any) {
   
    this.authCours.lastSelectedTab.next(event.index)
    if (event.index == 1) { //deactive
      this.is_active = '0';
      this.course_status = '2';
    }
    else if (event.index == 2) { // draft
      this.is_active = '1';
      this.course_status = '1';
    } else {
      this.is_active = '1';
      this.course_status = '2'; //active
    }
    this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
  }
  /****serach by course name */
  search(event: any) {
    this.course_name = event.target.value;
    this.courseSearch(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
  }
  /*******get listing course data***/
  courseList(course_name: any, is_active: any, course_status: any = this.course_status, order_by: any = this.order_by, order: any = this.order) {
    this.spinner.show();
    this.authCours.courseList(course_name, is_active, course_status, order_by, order).subscribe(
      data => {
        if (data.status == 201 || data.status == 200) {
          this.courseListData = data.course;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      }, error => {
        this.spinner.hide();
      }
    );
  }
  /*log out*/
  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  /*******get listing  search course data***/
  courseSearch(course_name: any, is_active: any, course_status: any = this.course_status, order_by: any = this.order_by, order: any = this.order) {

    this.authCours.courseList(course_name, is_active, course_status, order_by, order).subscribe(
      data => {
        if (data.status == 201 || data.status == 200) {
          this.courseListData = data.course;
        } else {
        }
      }, error => {
      }
    );
  }
  /******create duplicate course */
  duplicateCapsule(capsule_id: any, tab_name: any) {
    /*****get couse detail ****/
    this.spinner.show();
    this.authCours.CourseDetail(capsule_id).subscribe(
      data => {
        this.cousesData = data.courseData;
        this.courseForm = {
          "course_desc": data.courseData.course_desc,
          "course_id": "",
          "course_image": data.courseData.course_image,
          "course_name": data.courseData.course_name + '_copy',
          // "course_status": data.courseData.course_status,
          "course_status": 1,
          "created_by": data.courseData.db_created_dttm,
          "end_date": data.courseData.db_end_date,
          "is_active": data.courseData.is_active
        }
        this.authCours.dublicateCourse(this.courseForm).subscribe(
          (data) => {
            if (this.cousesData.courseModules.length > 0 && data.status == 201) {
              this.getModuleData(data.course_id, tab_name);

            } else {
              document.getElementById('closelId')?.click();
              if (tab_name == 'Active') {
                this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
              } else if (tab_name == 'Deactivated') {
                this.courseList(this.course_name, 0, 2, this.order_by, this.order);
              } else {
                this.courseList(this.course_name, 1, 1, this.order_by, this.order);
              }
              this.spinner.hide();
            }
          }, error => {
            this.spinner.hide();
          })
      })
  }
  getModuleData(courseId: any, tab_name: any) {
    if (this.cousesData && this.cousesData.courseModules) {
      let arr: Array<any> = this.cousesData.courseModules;
      arr.forEach((element, i) => {
        setTimeout(() => {
          let qts = element.subModules;
          for (let n = 0; n < qts.length; n++) {
            qts[n]['course_id'] = courseId;
            qts[n]['created_dttm'] = qts[n].db_created_dttm;
            qts[n]['created_by'] = qts[n].db_created_by;
          }
          element['course_id'] = courseId;
          element['created_dttm'] = element.db_created_dttm;
          element['created_by'] = element.db_created_by;
          element['subModules'] = qts;
          if (this.cousesData.courseModules.length - 1 == i) {
            this.duplicateModule(element, tab_name, 1);
          } else {
            this.duplicateModule(element, tab_name, 0);
          }
        }, i * 2000);
      })
      // this.spinner.hide();
    }
  }
  /*****create duplicate modules of course */
  duplicateModule(Modueldata: any, tab_name: any, status: any) {
    this.authCours.creatModule(Modueldata, 'create').subscribe(
      data => {
        if (status == 1) {
          if (tab_name == 'Active') {
            this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
          } else if (tab_name == 'Deactivated') {
            this.courseList(this.course_name, 0, 2, this.order_by, this.order);
          } else {
            this.courseList(this.course_name, 1, 1, this.order_by, this.order);
          }
          document.getElementById('closelId')?.click();
          this.spinner.hide();
        }

      }, error => {
        this.spinner.hide();
      })

  }
 
  successExtendDate() {
    console.log(this.datePipe.transform(this.extendForm.controls.endDate.value, 'YYYY-MM-dd h:mm:ss'))
    this.authCours.courseEndDateUpdate(this.courseIdEndDate, this.datePipe.transform(this.extendForm.controls.endDate.value, 'YYYY-MM-dd h:mm:ss')).subscribe(
      data => {
        if (data.status == 200) {
          this.activeCourse = false;
          this.succesCourse = true;
        }
      }, error => { })
  }
  successDate() {
    this.activeCourse = true;
    this.succesCourse = false;
    document.getElementById('closelId')?.click();
    this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
  }
  cousreEndDate(endDate: any) {
    var date2 = new Date();
    var date1 = new Date(endDate);
    var Time = date2.getTime() - date1.getTime();
    var Days = Time / (1000 * 3600 * 24);
    return Days;
  }
}



